<template>
  <div class="imgDialog">
    <div class="imgDialog-header">
      <span class="imgDialog-title">图片预览</span>
      <span class="imgDialog-close" @click="$emit('close')">X</span>
    </div>
    <div class="previewImage">
      <img :src="previewImage" alt="" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs, ref, onMounted, watch, onUnmounted } from 'vue';
const props = defineProps({
  previewImage: {
    type: String,
    default: '',
  },
});
</script>
<style scoped lang="scss">
.imgDialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  .imgDialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    .imgDialog-title {
      font-size: 16px;
      color: white;
    }
    .imgDialog-close {
      font-size: 20px;
      color: black;
      background: white;
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  .previewImage {
    width: 50%;
    margin: 0 auto;
  }
}
</style>
